export default __webpack_public_path__ + "static/media/assemblyH.09d0896b.png";